import { render, staticRenderFns } from "./floating.vue?vue&type=template&id=9a21ae62&lang=pug&"
import script from "./floating.vue?vue&type=script&lang=js&"
export * from "./floating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports